import { Box } from '@mui/material';
import { useCallback } from 'react';
import { BreadcrumbsBar } from '../breadcrumbs/breadcrumbsBar';
import { RulesRoute } from '../../routes/allRoutes';
import { HtmlViewerContainer } from '../../controls/html/htmlViewerContainer';
import { useInfoFeedData } from '../../hooks/useInfoFeedData';
import { InfoFeedClient } from '../../helpers/client';
import { NavBar } from '../appBars/navBar/navBar';
import { useTranslation } from 'react-i18next';
import { appStyleMode } from '../../helpers/clientConfigs';
import { AppStyle } from '../../helpers/appStyle';

export function TermsAndConditions() {
  const getTermsAndConditions = useCallback((client: InfoFeedClient) => client.getCompanyTermsAndConditions(), []);
  const termsAndConditions = useInfoFeedData<string>(getTermsAndConditions);
  const { t } = useTranslation();

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
      <NavBar barTitle={t('info:rules')} />
      <BreadcrumbsBar paths={[{ path: RulesRoute }]} />
      <Box className={appStyleMode === AppStyle.Mobile && 'policy-content'} sx={{ width: '100%' }}>
        <HtmlViewerContainer content={termsAndConditions} isLoading={!termsAndConditions} />
      </Box>
    </Box>
  );
}
